import React from 'react';
import { Box } from '@mui/material';
import { Text, TextTitle } from '../../../../Text';
import DeleteButton from '../../../../Buttons/DeleteButton';
import AddButton from '../../../../Buttons/AddButton';
import {
  getInitialForm8AreaDocuments,
  FORM8_AREA_DOCUMENTS_NAME,
} from '../../../../../constants/lkCadastr/cadastrForm8';
import { fitContent, flexGap2, fullWidth } from '../../../../../constants/lkCadastr/cadastrStorage';
import CustomInput from '../../../../Inputs';
import CustomDatePicker from '../../../../CustomDatePicker';
import useCadastreTabs from '../../../../../hooks/useCadastreTabs';
import NavTabs from '../../../../Tabs';
import { deleteForm8Entity } from '../../../../../helpers/cadastreForms/form8Helper';

export function Form8Areas({
  placingObject, changeObject, isDemo, openDeleteModal,
}) {
  const form8Areas = placingObject[FORM8_AREA_DOCUMENTS_NAME];

  const { tab, setTab, tabs } = useCadastreTabs({ items: form8Areas, tabName: 'Документ' });

  return (
    <Box sx={flexGap2}>
      <TextTitle h3>
        Правоустанавливающий документ на
        земельный участок, на котором расположен объект
      </TextTitle>
      {!isDemo && (
        <AddButton
          variant="outlined"
          onClick={() => changeObject(FORM8_AREA_DOCUMENTS_NAME, [...form8Areas, getInitialForm8AreaDocuments()])}
        >
          Добавить правоустанавливающий документ
        </AddButton>
      )}
      <NavTabs tab={tab} setTab={setTab} tabsComponents={tabs} />
      {form8Areas.map((form8Area, form8AreaIndex) => {
        if (tab !== form8Area.randId) return null;

        const onChange = (field, value) => {
          changeObject(`${FORM8_AREA_DOCUMENTS_NAME}.${form8AreaIndex}.${field}`, value, undefined, { areaDocumentIndex: form8AreaIndex });
        };

        const onDelete = async () => {
          if (form8Area.id) {
            await deleteForm8Entity({
              id: form8Area.id,
              apiType: FORM8_AREA_DOCUMENTS_NAME,
            });
          }

          const cloneArray = form8Areas.slice();
          cloneArray.splice(form8AreaIndex, 1);

          changeObject(FORM8_AREA_DOCUMENTS_NAME, cloneArray, 'delete');
        };

        return (
          <Box key={form8Area.randId} sx={flexGap2}>
            <TextTitle>
              Правоустанавливающий документ
              №
              {form8AreaIndex + 1}
            </TextTitle>
            {!isDemo && form8Areas.length > 1 && (
              <DeleteButton
                onClick={() => openDeleteModal(onDelete, form8AreaIndex, 'Правоустанавливающий документ')}
              >
                Удалить правоустанавливающий документ
              </DeleteButton>
            )}
            <Box sx={flexGap2}>
              <Box>
                <Text className="mute">Наименование документа о землеотводе</Text>
                <CustomInput
                  debounceTime={0}
                  validImmediately
                  disabled={isDemo}
                  sx={fullWidth}
                  value={form8Area.document_name}
                  onChange={(e, value) => onChange('document_name', value)}
                />
              </Box>
              <Box>
                <Text className="mute">Наименование органа, выдавшего документ о землеотводе</Text>
                <CustomInput
                  debounceTime={0}
                  validImmediately
                  disabled={isDemo}
                  sx={fullWidth}
                  value={form8Area.body_name}
                  onChange={(e, value) => onChange('body_name', value)}
                />
              </Box>
              <Box>
                <Text className="mute">Дата выдачи</Text>
                <CustomDatePicker
                  canBeZero
                  validImmediately
                  disabled={isDemo}
                  sx={fitContent}
                  value={form8Area.issue_date}
                  onChange={(e, value) => onChange('issue_date', value)}
                />
              </Box>
              <Box>
                <Text className="mute">Номер</Text>
                <CustomInput
                  debounceTime={0}
                  validImmediately
                  disabled={isDemo}
                  sx={fitContent}
                  value={form8Area.document_number}
                  onChange={(e, value) => onChange('document_number', value)}
                />
              </Box>
              <Box>
                <Text className="mute">Кадастровый номер земельного участка</Text>
                <CustomInput
                  debounceTime={0}
                  validImmediately
                  disabled={isDemo}
                  sx={fullWidth}
                  value={form8Area.cadastral_number_area}
                  onChange={(e, value) => onChange('cadastral_number_area', value)}
                />
              </Box>
              <Box>
                <Text className="mute">Собственник земельного участка</Text>
                <CustomInput
                  debounceTime={0}
                  validImmediately
                  disabled={isDemo}
                  sx={fullWidth}
                  value={form8Area.owner}
                  onChange={(e, value) => onChange('owner', value)}
                />
              </Box>
              <Box>
                <Text className="mute">Категория земельного участка</Text>
                <CustomInput
                  debounceTime={0}
                  validImmediately
                  disabled={isDemo}
                  sx={fullWidth}
                  value={form8Area.area_category}
                  onChange={(e, value) => onChange('area_category', value)}
                />
              </Box>
              <Box>
                <Text className="mute">Вид разрешённого использования</Text>
                <CustomInput
                  debounceTime={0}
                  validImmediately
                  disabled={isDemo}
                  sx={fullWidth}
                  value={form8Area.permitted_use_type}
                  onChange={(e, value) => onChange('permitted_use_type', value)}
                />
              </Box>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}
